import {ALERT_TYPES} from 'constants'

const AlertBar = ({message, type = ALERT_TYPES.danger}) => {
  return (
    <>
      {message && (
        <div className={`mb-lg-15 alert alert-${type}`}>
          <div className='alert-text font-weight-bold'>{message}</div>
        </div>
      )}
    </>
  )
}

export default AlertBar
